import { render } from "./OnboardingModal.vue?vue&type=template&id=315d0100&scoped=true"
import script from "./OnboardingModal.vue?vue&type=script&lang=js"
export * from "./OnboardingModal.vue?vue&type=script&lang=js"

import "./OnboardingModal.vue?vue&type=style&index=0&id=315d0100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315d0100"]])

export default __exports__